import api from "../../api"
import { SalesLeadsState, SalesLead } from "./salesLeadsModel"

export const salesLeadsEndpoint = `/web/sales-leads`

export const getSalesLeads = async (): Promise<SalesLead[]> => {
  return (await api.get<SalesLead[]>(salesLeadsEndpoint)).data
}

export const saveSalesLeads = async (changeSet: SalesLeadsState) => {
  return (await api.post(salesLeadsEndpoint, {...changeSet})).data
}